"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsService = void 0;
const unleash_proxy_client_1 = require("unleash-proxy-client");
const tiny_emitter_1 = require("tiny-emitter");
class FeatureFlagsService {
    constructor(options) {
        this.emitter = new tiny_emitter_1.TinyEmitter();
        this.client = new unleash_proxy_client_1.UnleashClient({
            url: this.prepareServiceUrl(options.serviceUrl),
            clientKey: options.clientKey,
            appName: options.applicationName,
            context: {
                userId: options.accountId,
                properties: options.context
            },
            refreshInterval: options.refreshIntervalInSeconds
        });
        this.client.on('ready', () => this.emitter.emit('ready'));
        this.client.on('update', () => this.emitter.emit('update'));
        this.client.on('error', () => this.emitter.emit('error'));
        this.client.start();
    }
    isFeatureEnabled(featureName) {
        return this.client.isEnabled(featureName);
    }
    on(eventName, callback) {
        this.emitter.on(eventName, callback);
    }
    off(eventName, callback) {
        this.emitter.off(eventName, callback);
    }
    prepareServiceUrl(serviceUrl) {
        var _a;
        try {
            const url = new URL(serviceUrl);
            url.pathname = 'api/frontend';
            return url.toString();
        }
        catch (e) {
            console.error(`Error during feature flags service URL parsing: ${(_a = e === null || e === void 0 ? void 0 : e.message) !== null && _a !== void 0 ? _a : e}`);
            return serviceUrl;
        }
    }
}
exports.FeatureFlagsService = FeatureFlagsService;
